export default {
  0: {
    type: 'info',
    text: '未分配', // 应用状态列表时暂时 text 字段
    auditLabel: '创建任务', // 审核历史列表 需要用到 auditLabel 字段
  },
  1: {
    type: 'info',
    text: '未分配', // 应用状态列表时暂时 text 字段
    auditLabel: '创建任务', // 审核历史列表 需要用到 auditLabel 字段
  },
  2: {
    type: 'info',
    text: '开发中',
    auditLabel: '分配任务',
  },
  // 2: {
  //   type: 'info',
  //   text: '提交中',
  //   auditLabel: '创建任务',
  // },
  4: {
    type: 'warning',
    text: '审核中',
    auditLabel: '提交审核',
  },
  5: {
    type: 'success',
    text: '审核通过',
    auditLabel: '审核通过',
  },
  6: {
    type: 'danger',
    text: '审核不通过',
    auditLabel: '审核不通过',
  },
  7: {
    type: 'success',
    text: '已上线',
    auditLabel: '已上线',
  },
  8: {
    type: 'info',
    text: '已下线',
    auditLabel: '已下线',
  },
};
